module.exports = require("react-tabs");